import { createProduct, initProduct } from "@/model/Product";
import { BookingDurationTypeModel } from "@/model/enum/BookingDurationType.model";
import { MapDeserializer } from "@/util/MapDeserializer";
import Timeslot from "@/model/Timeslot";
import { ResourceType } from "@/model/enum/ResourceType";
export class CartItem {
    product;
    dateFrom = new Date();
    dateTo = new Date();
    resourceReservations = {};
    prices = new Map();
    priceAdjustments = {};
    selectedTimeslot;
    constructor(product) {
        this.product = product;
        this.initWithProduct(product);
    }
    initWithProduct(product) {
        this.product = product;
        if (product.bookingDurationType == BookingDurationTypeModel.FIXED) {
            this.dateTo.setDate(this.dateFrom.getDate() + product.bookingIntervalLength - 1);
        }
        else if (product.bookingDurationType == BookingDurationTypeModel.VARIABLE && product.priceStructure.pricedPerNight) {
            this.dateTo.setDate(this.dateFrom.getDate() + 1);
        }
    }
    assign(other) {
        Object.assign(this, other);
        this.dateFrom = new Date(other.dateFrom);
        this.dateTo = new Date(other.dateTo);
        this.product = createProduct();
        initProduct(this.product, other.product);
        if (!(other instanceof CartItem)) {
            this.prices = MapDeserializer.deserializePriceAmountMap(other.prices);
        }
        if (other.selectedTimeslot) {
            this.selectedTimeslot = new Timeslot();
            this.selectedTimeslot.assign(other.selectedTimeslot);
        }
        return this;
    }
    getResourceTitle(resourceId) {
        let title = this.product.resources.find(resource => resource.id == resourceId)?.name;
        if (!title) {
            title = this.product.resourceGroups.flatMap(resourceGroup => resourceGroup.resources)
                .find(resource => resource.id == resourceId)?.name;
        }
        return title ? title : "";
    }
    getAttributeReservations() {
        return Object.entries(this.resourceReservations)
            .filter(([key]) => {
            const resource = this.product.resources.find(r => r.id === Number(key)) ||
                this.product.resourceGroups.flatMap(g => g.resources).find(r => r.id === Number(key));
            return resource?.resourceType === ResourceType.ATTRIBUTE;
        })
            .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    }
    getResourceReservations() {
        return Object.entries(this.resourceReservations)
            .filter(([key]) => {
            const resource = this.product.resources.find(r => r.id === Number(key)) ||
                this.product.resourceGroups.flatMap(g => g.resources).find(r => r.id === Number(key));
            return resource?.resourceType === ResourceType.RESOURCE;
        })
            .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    }
}
